import './string'
import './object'
import './array'
import './window'

export default {}
